/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection10FoiChanged, m11ReportSection10ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection10Foi, selectM11ReportSection10Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveStatisticsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section10State, setAlertModalState, setStartingSection10State) => {

  let changesStates = {
    section10State: section10State
  };
  let response = await saveM11Changes(apiToken, 34, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection10Resource) {
      dispatch(m11ReportSection10ResourceChanged(response.m11ReportSection10Resource));
    }
    setStartingSection10State(JSON.parse(JSON.stringify(section10State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step034CompleteStatistics = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection10Foi = useSelector(selectM11ReportSection10Foi);
  const m11ReportSection10Resource = useSelector(selectM11ReportSection10Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section10State, setSection10State] = useState({
    "section106Status": "empty", "section106Xhtml": "",
    "section107Status": "empty", "section107Xhtml": "",
    "section108Status": "empty", "section108Xhtml": "",
    "section109Status": "empty", "section109Xhtml": "",
    "section1010Status": "empty", "section1010Xhtml": "",
    "section1011Status": "empty", "section1011Xhtml": ""
  });
  const [startingSection10State, setStartingSection10State] = useState({
    "section106Status": "empty", "section106Xhtml": "",
    "section107Status": "empty", "section107Xhtml": "",
    "section108Status": "empty", "section108Xhtml": "",
    "section109Status": "empty", "section109Xhtml": "",
    "section1010Status": "empty", "section1010Xhtml": "",
    "section1011Status": "empty", "section1011Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section10State, startingSection10State)),
    async saveAllChanges() {
      await saveStatisticsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section10State, setAlertModalState, setStartingSection10State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section106Status": "empty", "section106Xhtml": "",
        "section107Status": "empty", "section107Xhtml": "",
        "section108Status": "empty", "section108Xhtml": "",
        "section109Status": "empty", "section109Xhtml": "",
        "section1010Status": "empty", "section1010Xhtml": "",
        "section1011Status": "empty", "section1011Xhtml": "",
        "loaded": true
      };
      setSection10State(startingData);
      setStartingSection10State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[10]?.entry?.length) {
        let m11ReportSection010Foi = getIdFromReference(m11ReportContainerResource.section[10].entry[0]);
        if (m11ReportSection010Foi && !isNaN(m11ReportSection010Foi) && m11ReportSection010Foi !== m11ReportSection10Foi) {
          dispatch(m11ReportSection10FoiChanged(m11ReportSection010Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection10Foi && !isNaN(m11ReportSection10Foi)) {
      loadResource(m11ReportSection10Foi, "M11ReportSection10", apiToken, dispatch);
    }
  }, [m11ReportSection10Foi]);

  useEffect(() => {
    if (m11ReportSection10Resource && Object.keys(m11ReportSection10Resource).length > 0) {
      let startingData = {
        "section106Status": "empty", "section106Xhtml": "",
        "section107Status": "empty", "section107Xhtml": "",
        "section108Status": "empty", "section108Xhtml": "",
        "section109Status": "empty", "section109Xhtml": "",
        "section1010Status": "empty", "section1010Xhtml": "",
        "section1011Status": "empty", "section1011Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection10Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection10Resource.section[0].section[5]?.text?.div &&
          m11ReportSection10Resource.section[0].section[5].text.status !== "empty") {
          startingData.section106Status = m11ReportSection10Resource.section[0].section[5].text.status;
          startingData.section106Xhtml = m11ReportSection10Resource.section[0].section[5].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[6]?.text?.div &&
          m11ReportSection10Resource.section[0].section[6].text.status !== "empty") {
          startingData.section107Status = m11ReportSection10Resource.section[0].section[6].text.status;
          startingData.section107Xhtml = m11ReportSection10Resource.section[0].section[6].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[7]?.text?.div &&
          m11ReportSection10Resource.section[0].section[7].text.status !== "empty") {
          startingData.section108Status = m11ReportSection10Resource.section[0].section[7].text.status;
          startingData.section108Xhtml = m11ReportSection10Resource.section[0].section[7].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[8]?.text?.div &&
          m11ReportSection10Resource.section[0].section[8].text.status !== "empty") {
          startingData.section109Status = m11ReportSection10Resource.section[0].section[8].text.status;
          startingData.section109Xhtml = m11ReportSection10Resource.section[0].section[8].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[9]?.text?.div &&
          m11ReportSection10Resource.section[0].section[9].text.status !== "empty") {
          startingData.section1010Status = m11ReportSection10Resource.section[0].section[9].text.status;
          startingData.section1010Xhtml = m11ReportSection10Resource.section[0].section[9].text.div;
        }
        if (m11ReportSection10Resource.section[0].section[10]?.text?.div &&
          m11ReportSection10Resource.section[0].section[10].text.status !== "empty") {
          startingData.section1011Status = m11ReportSection10Resource.section[0].section[10].text.status;
          startingData.section1011Xhtml = m11ReportSection10Resource.section[0].section[10].text.div;
        }
        setSection10State(startingData);
        setStartingSection10State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection10Resource]);

  return <div>
    <h3>Complete Section 10 Statistical Considerations</h3>
        {!(m11ReportSection10Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 34 (Complete Section 10 Statistical Considerations) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section10State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.6 Analyses Associated with the Exploratory Objective(s) as needed.</h4>
          <TextDivEntry elementName="section106Xhtml"
            startingValue={section10State.section106Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.7 Safety Analyses as needed.</h4>
          <TextDivEntry elementName="section107Xhtml"
            startingValue={section10State.section107Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.8 Other Analyses as needed.</h4>
          <TextDivEntry elementName="section108Xhtml"
            startingValue={section10State.section108Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.9 Interim Analyses as needed.</h4>
          <TextDivEntry elementName="section109Xhtml"
            startingValue={section10State.section109Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.10 Multiplicity Adjustments as needed.</h4>
          <TextDivEntry elementName="section1010Xhtml"
            startingValue={section10State.section1010Xhtml}
            setResourceState={setSection10State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 10.11 Sample Size Determination as needed.</h4>
          <TextDivEntry elementName="section1011Xhtml"
            startingValue={section10State.section1011Xhtml}
            setResourceState={setSection10State} />
        </>}
      </>
    }
  </div >
});

const M11Step034CompleteStatisticsHelperText = <div>
  <h3>Complete Section 10 Statistical Considerations</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 10.6 Analyses Associated with the Exploratory Objective(s).</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe any exploratory analyses, if applicable. Additional subsections may be created to describe the analyses for each exploratory objective, as needed. If there is no exploratory objective, indicate “Not applicable”.</p>
    </div>
    <p>Enter data for Section 10.7 Safety Analyses.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>If safety is a primary and/or secondary objective, describe the corresponding safety analyses in the appropriate section above (Section 10.4 Analyses Associated with the Primary Objective[s] or Section 10.5 Analyses Associated with the Secondary Objective[s]). In this section, describe statistical methods that will be used to analyse relevant safety outcomes, including any AESI. This should typically include specification of a measure to estimate risk within treatment arms, a measure to compare risks across treatment arms, and a measure of statistical uncertainty around the comparison (e.g., a confidence interval).</p>
    </div>
    <p>Enter data for Section 10.8 Other Analyses</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe other analyses not included in Sections 10.3-10.7, such as subgroup analyses.</p>
    </div>
    <p>Enter data for Section 10.9 Interim Analyses</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe any interim analyses and criteria for stopping or adapting the trial. Ensure alignment with Section 4.3 Trial Stopping Rules.</p>
      <p>The description should include, but is not limited to, the following. Under circumstances where interim analysis details could impede the integrity of the trial, some of the information can be added in other documents outside of the protocol.</p>
      <div style={{ marginLeft: "24px" }}>
        <p>•	any planned interim analysis, even if it is only to be performed at the request of an oversight body (for example, DMC)</p>
        <p>•	the purpose of the interim analysis, including whether the interim analysis may be used for stopping and/or other trial adaptations (e.g., sample size re-estimation, alteration to the proportion of participants allocated to each trial group, or changes to eligibility criteria)</p>
        <p>•	the applied statistical method (e.g., group sequential test) and spending function (e.g., O’Brien-Fleming), as applicable</p>
        <p>•	the parties responsible for performing and reviewing the results of the analyses (e.g., DMC, independent statistician)</p>
        <p>•	when the analyses will be conducted (timing and/or triggers)</p>
        <p>•	the decision criteria—statistical or other—that will be adopted to judge the interim results as part of a guideline for early stopping or other adaptations</p>
        <p>•	who will see the outcome data while the trial is ongoing</p>
        <p>•	whether these individuals will remain blinded to trial groups</p>
        <p>•	how the integrity of the trial will be protected (e.g., maintaining blinding) when decisions are made after interim analyses (e.g., a decision to continue the trial or implement a specific adaptation)</p>
      </div>
    </div>
    <p>Enter data for Section 10.10 Multiplicity Adjustments</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Multiple testing procedures may be needed to limit the probability of false positive findings in a trial. Reasons for carrying out multiple statistical tests include, but are not restricted to, multiple endpoints, multiple treatment groups, multiple hypotheses, subgroups, and multiple timepoints.</p>
      <p>Describe any approaches to multiplicity control for the trial. This description might go beyond the analysis of primary objectives.</p>
      <p>Specify the statistical approach to control the overall type I error rate as well as the (adjusted) significance levels to test specific hypotheses, as applicable. Clarify whether the tests/confidence intervals are one- or two-sided.</p>
      <p>State the circumstances under which a trial will be considered to have met its primary objective(s). For example, in a study with two primary efficacy endpoints, this section should state whether the study would be expected to provide statistical evidence on at least one or on both of the endpoints in order to confirm the efficacy of the treatment.</p>
      <p>For some statistical approaches it might be helpful to include a graphical depiction, as visualisation will be helpful for understanding, coupled with the clinical translation of the mathematical choices.</p>
      <p>Details regarding interim analyses should be provided in Section 10.9 Interim Analyses.</p>
    </div>
    <p>Enter data for Section 10.11 Sample Size Determination </p>
    <div style={{ marginLeft: "24px" }} >
      <p>This section should detail the methods used for the determination of the sample size.</p>
      <p>The sample size calculation should be aligned with the primary estimand(s) and the primary analysis; otherwise, a justification is needed. Details of sample size calculation should include all relevant information to enable reproduction of the sample size, e.g.,:</p>
      <div style={{ marginLeft: "24px" }}>
        <p>•	references to any prior studies on which assumptions were based</p>
        <p>•	significance level (including information on the choice of one- or two-sided level)</p>
        <p>•	power</p>
        <p>•	assumed treatment effect and variability</p>
        <p>•	how dropout rate and intercurrent events have been incorporated into sample size calculation</p>
        <p>•	precision of estimator/length of confidence interval</p>
      </div>
      <p>Any assumptions made should be stated and justified. Further analysis of how deviations from the assumptions will affect the sample size should be included.</p>
      <p>If complex simulations were used to calculate the sample size, consider including details in a separate simulation report as an appendix to the protocol.</p>
      <p>If the planned sample size is not derived statistically, then this should be explicitly stated along with a rationale for the intended sample size (e.g., exploratory nature of pilot trials; pragmatic considerations for trials in rare diseases).</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>
// eslint-disable-next-line no-empty-pattern
const M11Step034CompleteStatisticsValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 34, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 34 (Complete Section 10 Statistical Considerations) {validationCheckState.step34numberOfChecks} issues checked. {validationCheckState.step34numberPassed} passed. {validationCheckState.step34numberFailed} failed.</h4>
    <p>Section 10 heading is 'STATISTICAL CONSIDERATIONS': {validationCheckState.resultCheckSection10Heading}</p>
    <p>Section 10 STATISTICAL CONSIDERATIONS does not have text: {validationCheckState.resultCheckSection10Text}</p>
    <p>Section 10.6 heading is 'Analyses Associated with the Exploratory Objective(s)': {validationCheckState.resultCheckSection106Heading}</p>
    <p>Section 10.6 Analyses Associated with the Exploratory Objective(s) has content: {validationCheckState.resultCheckSection106Content}</p>
    <p>Section 10.7 heading is 'Safety Analyses': {validationCheckState.resultCheckSection107Heading}</p>
    <p>Section 10.7 Safety Analyses has content: {validationCheckState.resultCheckSection107Content}</p>
    <p>Section 10.8 heading is 'Other Analyses': {validationCheckState.resultCheckSection108Heading}</p>
    <p>Section 10.8 Other Analyses has content: {validationCheckState.resultCheckSection108Content}</p>
    <p>Section 10.9 heading is 'Interim Analyses': {validationCheckState.resultCheckSection109Heading}</p>
    <p>Section 10.9 Interim Analyses has content: {validationCheckState.resultCheckSection109Content}</p>
    <p>Section 10.10 heading is 'Multiplicity Adjustments': {validationCheckState.resultCheckSection1010Heading}</p>
    <p>Section 10.10 Multiplicity Adjustments has content: {validationCheckState.resultCheckSection1010Content}</p>
    <p>Section 10.11 heading is 'Sample Size Determination': {validationCheckState.resultCheckSection1011Heading}</p>
    <p>Section 10.11 Sample Size Determination has content: {validationCheckState.resultCheckSection1011Content}</p>
    </div>}  </div>
}

export default M11Step034CompleteStatistics;
export { M11Step034CompleteStatisticsHelperText, M11Step034CompleteStatisticsValidationCheck };